<template>
  <i class="icon-32" :class="{ clickable: clickable, [name + '-icon-32']: true }" @click="click"></i>
</template>

<script>
export default {
  props: {
    clickable: Boolean,
    name: String
  },
  methods: {
    click () {
      if (!this.clickable) return
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.icon-32 { background: url(../../assets/icons-32.png); display: inline-block; height: 32px; width: 32px; }
.icon-32.clickable { cursor: pointer; opacity: .9; -webkit-transition: opacity 0.3s; -moz-transition: opacity 0.3s; -o-transition: opacity 0.3s; transition: opacity 0.3s; }
.icon-32.clickable:hover { opacity: 1; }
.close-icon-32 { background-position: 0 0; }
</style>



// WEBPACK FOOTER //
// src/components/icons/Icon32.vue